import React from 'react';
import i_ver from '../../UI/ver.png'
import i_back from '../../UI/back_simple.png';
import i_visto from '../../UI/ver_oprimido.png';
import { torreFilterCanva } from '../../redux/actions';

const BarEtapasComponent = (
    { proyecto, selectedTorre, handleShowTorre, handleContractTorre, handleSelectApto, selectedApto, barHidden, handleSelectFloor, handleDeselectFloor, selectedFloor, handleShowAptoTipo}
    ) => {

    return (
        <div className={`bar-etapas ${barHidden ? "hidden":""}`}>
        <div className="etapa-header">Bienvenidos</div>
            <div>
                {
                    proyecto.Etapas &&
                    proyecto.Etapas.map(( {Torres}, indexEtapa) =>
                        
                        <div key={indexEtapa}>
                            <h3>Etapa {indexEtapa + 1}</h3>
                        { 
                            Torres.map((Torre, indexTorre) =>
                            <div>                
                                <button className="btn-etapas btn-torres" key={indexTorre} 
                                    onClick={ selectedTorre !== Torre.Nombre ? 
                                        () => {
                                        //if(Torre.Nombre === "Torre 1"){
                                            handleShowTorre({
                                                index: Torre.Nombre,
                                                nombre: Torre.Nombre,
                                            }) 
                                        //}                                        
                                        }
                                        :
                                        () => handleContractTorre() 
                                        } 
                                    >
                                    <div className="info-btn"> 
                                        <img src={i_ver}/>
                                        <span>{Torre.Nombre} </span>
                                        <img className={selectedTorre === Torre.Nombre ? "contract-icon": "expand-icon" } src={i_back}/>
                                    </div>
                                    <hr></hr>
                                </button>

                                    {
                                        selectedTorre === Torre.Nombre ? 
                                            Torre.AptosTipo.map((aptoTipo , indexTipoApto)  => 
                                                aptoTipo.Nombre.split(' ')[1] !== "01" ?
                                                <div>
                                                <button className="btn-etapas" 
                                                    /*onClick={(event) => handleShowAptoTipo({aptoTipo: aptoTipo, index:indexTipoApto})}*/
                                                    onClick={(event) => 
                                                        {
                                                            
                                                            handleSelectApto({
                                                                aptoTipo: aptoTipo/*, 
                                                                apto: apto*/
                                                            }); 
                                                        }
                                                    }
                                                    key={indexEtapa*7+indexTipoApto} >
                                                    <div className="info-btn">
                                                        <img src={i_ver}/>
                                                        <span>{aptoTipo.Nombre}</span>
                                                        <img className="expand-icon" src={i_back}/>
                                                    </div>
                                                    <hr></hr>
                                                </button>    
                                                
                                                {
                                                    selectedApto === aptoTipo ?
                                                    <div>
                                                        <div className="data-tipo-apto">
                                                            {aptoTipo.Areas.map((area, indexApto) =>
                                                                <p key={indexApto}>
                                                                    {area.Nombre}: {area.Valor} 
                                                                </p>
                                                            )}
                                                        </div>
                                                    </div>
                                                    :
                                                    <div></div>
                                                }
                                                </div>:<></>
                                            )
                                            :
                                            <div></div>
                                    }
                            </div>
                            
                            )
                            
                            }
                                                            
                        </div>


                    )

                }

                {/* <button className="btn-etapas btn-torres" onClick={(event) => this.handleShowEtapa()} >
                    <div className="info-btn">
                        <img src={i_ver}/>
                        <span>Torre Norte</span>
                        <img className="expand-icon" src={i_back}/>
                    </div>
                    <hr></hr>
                </button>     */}

                
            </div>
            {/* <button className="hide-btn"  ><img className="hidden-btn-img" src={i_back}/></button> */}

        </div>
        
    );
};


export default BarEtapasComponent;